import Link from 'next/link'
import styled from 'styled-components'

import Row from '@totallymoney/ui/components/Row'
import anchorStyles from '@totallymoney/ui/styles/anchor'

export const StyledNextAnchor = styled(Link)`
    ${anchorStyles};
`

export const StyledRowScroller = styled(Row)`
    overflow-y: scroll;
    scrollbar-width: none;
`
